import { AbstractControl, ValidatorFn } from '@angular/forms';

export class EmailValidator {
    static emailDomainValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const email = control.value;
            if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                return { emailDomain: true };
            }

            return null;
        };
    }
}
